import { render, staticRenderFns } from "./accordion-hotel-kind.vue?vue&type=template&id=669868e0"
import script from "./accordion-hotel-kind.js?vue&type=script&lang=js&external"
export * from "./accordion-hotel-kind.js?vue&type=script&lang=js&external"
import style0 from "./accordion-hotel-kind.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports